define.alias("ember-intl/helpers/format-number", "calendar/helpers/format-number");